import React from 'react';

interface HubSectionProps {
    ariaLabel?: string;
}

const HubSection: React.FC<HubSectionProps> = props => {
    const { children, ariaLabel } = props;
    const ariaProps = ariaLabel ? { 'aria-label': ariaLabel, tabIndex: 0 } : {};
    return children ? <section {...ariaProps}>{children}</section> : null;
};

export default HubSection;
